import { memo, useState } from "react";

import { Box, TextField } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useAppContext } from "../../../../context/appContext";
import KsbDialogActions from "../../../../components/KsbDialogActions";
import BoxHeader from "../../../../../3_apps/5_Husibuech/components/1_Boxes/BoxHeader";
import userService from "../../../../service/user.service";

function UsernameDetail() {
  const theme = useTheme();
  const [change, setChange] = useState(false);
  const [localLoading, setLocalLoading] = useState(false);
  const { currentUser, setCurrentUser } = useAppContext();
  // console.log(currentUser)

  const [nickName, setNickName] = useState(
    currentUser.userNickName ? currentUser.userNickName : "",
  );

  const changeNickName = (event) => {
    event.target.value === currentUser.nickName ||
    (currentUser.nickName === undefined && event.target.value === "")
      ? setChange(false)
      : setChange(true);
    setNickName(event.target.value);
  };

  const updateLocalUser = () => {
    var updateUser = currentUser;
    if (nickName !== updateUser.userNickName) {
      updateUser.userNickName = nickName;
    }
    // console.log(updateUser);
    setCurrentUser(updateUser);
    localStorage.setItem("user", JSON.stringify(updateUser));
  };

  const updateHandler = (event) => {
    event.preventDefault();
    // alert("function not implemented yet");
    setLocalLoading(true);
    userService
      .updateUser("nickName", { nickName: nickName }, currentUser.id)
      .then(updateLocalUser())
      .then(setLocalLoading(false))
      .then(setChange(false));
    // console.log(currentUser);
  };

  const clearHandler = (event) => {
    event.preventDefault();
    setNickName(currentUser.nickName ? currentUser.nickName : "");
    setChange(false);
  };
  const sectionStyle = (theme) => ({
    backgroundColor: theme.palette.background.paper,
    borderRadius: 2,
    padding: theme.spacing(3),
    boxShadow: 2,
  });

  return (
    <Box sx={sectionStyle(theme)}>
      <BoxHeader title="Username einstellen" />

      <Box sx={{ mt: 2 }}>
        <TextField
          fullWidth
          label="Username"
          value={nickName}
          onChange={changeNickName}
        />

        {change && (
          <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
            <KsbDialogActions
              onCancel={clearHandler}
              onConfirm={updateHandler}
              confirmLabel={"Speichern"}
              confirmDisabled={localLoading}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
}
export default memo(UsernameDetail);
